import { useRepositorySuspenseQuery } from '@mews-commander/data-access';

export const useCustomerDetail = ({ customerId }: { customerId: string }) => {
    const { data: customer } = useRepositorySuspenseQuery(
        'accounts',
        'getAll',
        { accountIds: [customerId] },
        { select: ({ customers }) => customers?.[0] }
    );

    return customer;
};
